import * as React from "react";
import { cn } from "../lib/cn";

// Table container: surface.card, border.default, radius.lg, overflow hidden, so focus rings inside are inset
// (ui-spec §3.1, §1.3). Rows are real <tr>; the stretched name link lives in a cell. It is the containing block
// for absolutely positioned cell content (sr-only labels), so a wide table scrolls here and never widens the page.
export function TableCard({ className, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("relative overflow-x-auto rounded-lg border border-line bg-card", className)} {...props} />;
}

export function Table({ className, ...props }: React.ComponentProps<"table">) {
  return <table className={cn("w-full caption-bottom border-collapse text-ui", className)} {...props} />;
}

export function THead({ className, ...props }: React.ComponentProps<"thead">) {
  return <thead className={cn("bg-subtle", className)} {...props} />;
}

export function TR({ className, ...props }: React.ComponentProps<"tr">) {
  return (
    <tr
      className={cn("relative border-b border-line-subtle last:border-b-0 hover:bg-hover", className)}
      {...props}
    />
  );
}

export function TH({ className, ...props }: React.ComponentProps<"th">) {
  return (
    <th
      scope="col"
      className={cn(
        "h-[var(--nd-table-header-height)] border-b border-line px-[var(--nd-cell-padding-x)] text-left align-middle text-small font-medium whitespace-nowrap text-fg-muted",
        className,
      )}
      {...props}
    />
  );
}

export function TD({ className, ...props }: React.ComponentProps<"td">) {
  return (
    <td
      className={cn("px-[var(--nd-cell-padding-x)] py-1.5 align-middle text-ui text-fg-secondary", className)}
      {...props}
    />
  );
}
